import {
  AccountSelectListQuickFilterValue,
  AccountSelectListState,
  getAccountSelectListQuickFilter,
} from '../types/account-select-list';

export const DEFAULT_ACCOUNT_SELECT_PAGE_SIZE = 10;

export const getInitialAccountSelectListState = (): AccountSelectListState => ({
  params: {
    filters: [getAccountSelectListQuickFilter(AccountSelectListQuickFilterValue.LAST_MONTH)],
    page: 0,
    pageSize: DEFAULT_ACCOUNT_SELECT_PAGE_SIZE,
    searchQuery: undefined,
    listByEntity: undefined,
    status: undefined,
    selectedItemId: undefined,
  },
  api: {
    total: undefined,
    items: [],
    isLoading: false,
    error: undefined,
  },
});
